import type { AppUser } from "../types/user";

// Single source of truth for role names (mirrors backend app/auth/roles.py).
export const ROLES = {
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
  ANALYST: "analyst",
  VIEWER: "viewer",
} as const;

export type RoleName = (typeof ROLES)[keyof typeof ROLES];

// Highest → lowest privilege.
export const ALL_ROLES: RoleName[] = [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.ANALYST, ROLES.VIEWER];

// Privileged roles that may see admin surfaces.
export const ADMIN_ROLES: RoleName[] = [ROLES.ADMIN, ROLES.SUPER_ADMIN];

// Roles that may use analyst-grade tooling (custom alerts, warehouse SQL authoring, …).
export const ANALYST_ROLES: RoleName[] = [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.ANALYST];

type WithRole = { role?: { name?: string | null } | null } | null | undefined;

export const isAdmin = (user: WithRole): boolean =>
  ADMIN_ROLES.includes((user?.role?.name ?? "") as RoleName);

export const hasRole = (user: AppUser | null | undefined, roles: readonly string[]): boolean =>
  roles.includes(user?.role?.name ?? "");
